export default __webpack_public_path__ + "static/media/bh2.710eef34.webp";